<template>
  <div class="main-body">
    <div class="header">老人录入</div>
    <div class="out">
      <div class="search2">

        <el-button plain type="primary" size="mini" @click.native="toggleModalAdd">录入</el-button>

        <download-excel
            class = "export-excel-wrapper"
            :fetch           = "fetchData"
            :fields          = "json_fields"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload"
            name = "老人列表.xls"
            style="display: inline-block;margin-left: 5px;">
          <el-button plain type="success" size="mini">导出</el-button>
        </download-excel>

        <div style="float:right">

          <el-select v-model="institutionCode" placeholder="请选择机构" style="margin-right: 5px;">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 5px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-button type="primary" size="mini" plain icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                ref="table" border stripe v-loading="loading">

        <el-table-column prop="name" fixed="left" label="姓名" width="100"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
        <el-table-column prop="idCard" label="身份证号" width="150"></el-table-column>
        <el-table-column prop="age" label="年龄" width="80"></el-table-column>
        <el-table-column prop="urgencyContact" label="紧急联系人" width="120"></el-table-column>
        <el-table-column prop="urgencyPhone" label="紧急联系人手机" width="150"></el-table-column>

        <el-table-column prop="elderlyFund.balance" label="余额" width="100"></el-table-column>
        <el-table-column prop="elderlyFund.advance" label="预交金" width="100"></el-table-column>
        <el-table-column prop="elderlyFund.imprest" label="备用金" width="100"></el-table-column>

        <el-table-column prop="checkinStatus" label="签约状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.checkinStatus == 0">未签约</span>
            <span v-if="scope.row.checkinStatus == 1">已签约</span>
            <span v-if="scope.row.checkinStatus == 2">已入住</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">默认</span>
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 2">禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="zoneCodePathName" label="所在组织" width="300" ></el-table-column>
        <el-table-column prop="homeAddress" label="家庭住址" width="300" ></el-table-column>
        <el-table-column prop="elderlyClassName" label="分类" width="100" ></el-table-column>

        <el-table-column prop="createTime" :formatter="getTime" label="注册时间" min-width="180"></el-table-column>

        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="handleView(scope.row)">档案</el-button>
            <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-bind:arr_ins="arr_ins"
         v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    <ViewInfo ref="myViewInfo" v-show="showModalView" v-on:closeView="closeView" v-on:getList="getList"></ViewInfo>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Add from "./AddIns";
import Edit from "./Edit";
import ViewInfo from "../PageForGov/ViewInfo2";

import Elderly from "@/views/Elderly/Comm/ElderlyInsSigning3";


export default {
  name: "Role",
  data() {
    return {

      loading: false,
      showModal:false,

      showModalAdd: false,
      showModalEdit: false,
      showModalGetElderly:false,
      showModalView: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      arr_ins:[],
      institutionCode: '',

      elderlyCode:'',
      userName:'',

      type:2,

      json_fields: {
        "姓名": "name",
        "手机号": "phone",
        "身份证号": {
          field:"idCard",
          callback:value=>{
            return value+"-";
          }
        },
        "年龄": "age",
        "联系人": "urgencyContact",
        "联系人手机": "urgencyPhone",
        "余额": "elderlyFund.balance",
        "预交金": "elderlyFund.advance",
        "备用金": "elderlyFund.imprest",
        "分类": "elderlyClassName",
        "区域": "zoneCodePathName",
        "地址": "homeAddress",
        "注册时间": {
          field:"createTime",
          callback:value=>{
            if(value == ''){
              return "";
            }
            return timefilters(value);
          }
        },

      },

    }
  },
  components: {
    Edit,Add,ViewInfo,Elderly
  },

  created() {
    this.getIns();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.type,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.type,this.institutionCode);
    },
    setElderly(row){
      this.elderlyCode = row.elderlyCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.elderlyCode = '';
      this.userName = '';
    },


    getTime(row,index,column){
      return timefilters(column)
    },


    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },

    handleView(row) {
      this.$refs.myViewInfo.init(row);
      this.showModalView = !this.showModalView;
    },
    closeView(){
      this.showModalView = !this.showModalView;
    },




    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.loading=true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyAdm/GovPageIns",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          elderlyCode:this.elderlyCode,
        }
      }).then((response) => {
        this.loading=false;

        if (response.data.error == 0) {

          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          this.$nextTick(()=>{this.$refs.table.doLayout()});

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        //this.loading=false;
        console.log(error);
      });
    },


    async fetchData(){

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        institutionCode:this.institutionCode,
        pageIndex:1,
        pageSize:99999,
        elderlyCode:this.elderlyCode,
      }

      const response = await this.$axios.post(this.$shopUrl + "ElderlyAdm/GovPageIns",data);
      return response.data.data.pageInfo.list;
    },

    startDownload:function (){
      this.showModal = true;
    },

    finishDownload:function (){
      this.showModal = false;
    },

    del(row){
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.del_do(row.elderlyCode);
      }).catch(e=>e)
    },
    del_do(elderlyCode){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyAdm/GovDeleteIns",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode:elderlyCode,
        }
      }).then((response) => {
        if (response.data.error == 0) {

          this.getList();

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        //this.loading=false;
        console.log(error);
      });

    },


  }
}
</script>

<style lang="scss" scoped>

.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}
.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;
}
</style>
